<template>
  <div class="links">
    <h2>{{ headline }}</h2>
    <p v-if="message">
      {{ message }}
    </p>

    <div class="links__buttons">
      <!-- anchors styled as buttons, so the browser does the navigation and a
           target of _top or _blank counts as the user's own click -->
      <a
        v-for="link in links"
        :key="link.url"
        :href="link.url"
        :target="link.target || '_blank'"
        :rel="(link.target || '_blank') === '_blank' ? 'noopener' : null"
        class="el-button el-button--primary"
      >
        {{ link.label }}
      </a>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .links
    margin-top 20%
    padding 0 10%
    text-align center

  .links__buttons
    display flex
    justify-content center
    gap calc(var(--gap) * 2)
    margin-top calc(var(--gap) * 2)

    a
      text-decoration none
</style>

<script>
  import stopsLoading from '../lib/mixins/stopsLoading'

  /**
   * Generic page offering one or more links as buttons
   *
   * Each link is { label, url, target }. target defaults to _blank; _top
   * replaces the page embedding the iframe, which the embedding page has to
   * allow.
   */
  export default {
    name: 'Links',

    mixins: [
      stopsLoading
    ],

    props: {
      headline: {
        type: String,
        required: true
      },

      message: {
        type: String,
        default: ''
      },

      links: {
        type: Array,
        required: true
      }
    }
  }
</script>
